module.exports = __webpack_public_path__ + "img/ee4d957.png";